var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"visible":_vm.visible,"width":850},on:{"close":_vm.close}},[_c('img',{attrs:{"src":_vm.url,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }